var _excluded = ["heading", "subHeading"];
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import React from 'react';
import { Flex } from '../../../components/layout';
import { tqc, useMultiStyleConfig } from '../../../system';
/**
 * Component for the start of the timeline within an activity feed.
 * @param props props for component
 */
export var ActivityStartItem = props => {
  var {
      heading,
      subHeading
    } = props,
    rest = _objectWithoutProperties(props, _excluded);
  var {
    container,
    marker,
    timeline,
    contentContainer,
    contentHeading,
    contentSubHeading
  } = useMultiStyleConfig('ActivityStartItem', rest);
  return /*#__PURE__*/React.createElement(tqc.li, {
    __css: container
  }, /*#__PURE__*/React.createElement(Flex, {
    flexShrink: 0,
    flexBasis: "30px",
    alignItems: "center",
    flexDirection: "column"
  }, /*#__PURE__*/React.createElement(tqc.div, {
    __css: marker
  }), /*#__PURE__*/React.createElement(tqc.div, {
    __css: timeline
  })), /*#__PURE__*/React.createElement(Flex, {
    __css: contentContainer
  }, /*#__PURE__*/React.createElement(tqc.div, null, /*#__PURE__*/React.createElement(tqc.p, {
    __css: contentHeading
  }, heading), subHeading && /*#__PURE__*/React.createElement(tqc.p, {
    _css: contentSubHeading
  }, subHeading))));
};